import styled from "styled-components";
import colours from "styles/colours";

export const CustomSwaggerContainer = styled.div`
  margin-top: 1.5rem;

  .opblock-description-wrapper {
    display: none;
  }

  .opblock-summary .copy-to-clipboard {
    display: none;
  }

  // Bulma overrides
  ul.tab {
    margin-left: 0;
    margin-right: 0;

    li + li {
      margin-top: 0;
    }
  }

  code {
    color: inherit;
  }
`;

export const Surtitle = styled.h3`
  && {
    margin-bottom: 0;
    color: ${colours.focusBlue};
  }
`;

export const Title = styled.h2`
  &&& {
    margin-top: 0.5rem;
  }
`;
